// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/bigcommerce-storefront/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/bigcommerce-storefront/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1s-0 {\n  min-width: 400px;\n  width: 400px;\n  max-width: 400px;\n  position: relative;\n}\n\n._1s-1 {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n}\n", ""]);
// Exports
export var pickerModal = "_1s-0";
export var xButton = "_1s-1";
export default ___CSS_LOADER_EXPORT___;
